namespace Matrix.Data {
    export interface AccountModelTargetImportResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        Deleted?: number;
        ErrorList?: string[];
    }
}
